import type { SyntheticEvent } from 'react';
import { format, parseISO } from 'date-fns';

/** Matches admin Users list (`/users`) last-access formatting. */
export function formatUserListLastAccess(iso: string): string {
  return format(parseISO(iso), 'MM/dd/yy h:mm a');
}

/** Matches admin Users list “Created” column (date only). */
export function formatUserListDateShort(iso: string): string {
  return format(parseISO(iso), 'MM/dd/yy');
}

export function buildSpoofHref(email: string, locationSearch: string): string {
  return (
    '/dashboard' +
    locationSearch +
    (locationSearch.indexOf('?') < 0 ? '?' : '&') +
    'spoof=' +
    encodeURIComponent(email)
  );
}

export function stopRowClick(e: SyntheticEvent) {
  e.stopPropagation();
}
